import TagsModal from './TagsModal';

export default TagsModal;
